import React from "react"
import { Form } from "react-bootstrap"
import { PaginationItem } from "@src/components"

const DEVICES_LENGTH = [20, 50, 100] as const

export type PaginationControlsProps = {
  activePage: number
  pagesCount: number
  onChangePage: (page: number) => void
  devicesLength: number
  onChangeDevicesLength: (value: number) => void
  rightContent?: React.ReactNode
}

export const PaginationControls: React.FC<PaginationControlsProps> = ({
  activePage,
  pagesCount,
  onChangePage,
  devicesLength,
  onChangeDevicesLength,
  rightContent,
}) => {
  return (
    <div className="d-flex align-items-start flex-row flex-wrap gap-2 mb-2">
      <PaginationItem activePage={activePage} pagesCount={pagesCount} onChangePage={onChangePage} />
      <div className="ms-2">
        <Form.Select
          className="d-flex"
          name="fleets"
          id="fleets"
          onChange={(event) => {
            const nextValue = parseInt(event.target.value)
            onChangeDevicesLength(nextValue)
          }}
          value={devicesLength}
        >
          {DEVICES_LENGTH.map((item) => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </Form.Select>
      </div>
      {rightContent && <div className="ms-auto d-flex">{rightContent}</div>}
    </div>
  )
}
